export default __webpack_public_path__ + "img/33ca4fdc6886940e56eb31e53f415227.png";